import { normalize } from "common/lib/normalize";
import { getPositionTypes } from "common/services/payments.service";
import { useEffect, useMemo, useState } from "react";
import Select from "react-select";

type PositionTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const PositionTypeFilter = ({ onChange, value }: PositionTypeFilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };
  const [, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPositionTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          fields: ["id", "name"],
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <Select
      name="positionType"
      id="positionType"
      isSearchable
      isClearable
      placeholder="Select position type"
      onChange={onChange}
      options={options}
      value={value}
      styles={customSelectStyles}
    />
  );
};

export default PositionTypeFilter;
